import { customersApi } from '@/api';

const stabilityFilters = [
  {
    name: 'name',
    label: 'stability.name',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'status',
    label: 'status',
    type: 'select',
    whereOperator: '=',
    options: [
      { label: 'enums.stabilityStatus.pending', value: 'pending' },
      { label: 'enums.stabilityStatus.processing', value: 'processing' },
      { label: 'enums.stabilityStatus.configured', value: 'configured' },
      { label: 'enums.stabilityStatus.error', value: 'error' },
    ],
  },
  {
    name: 'orderId',
    label: 'orderId',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'sampleId',
    label: 'customerSampleId',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'customerId',
    label: 'customerIdOrName',
    type: 'autocomplete',
    whereOperator: '=',
    path: 'sample.order.customerId',
    autocompleteSearch: async (queryString, cb) => {
      const customersResponse = await customersApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      const filteredResults = customersResponse.data.map((c) => ({
        label: `${c.id} ${c.name}`,
        value: c.id,
      }));
      cb(filteredResults);
    },
  },
  {
    name: 'createdAt',
    label: 'stability.createdAt',
    type: 'dateRange',
  },
  {
    name: 'configuredAt',
    label: 'stability.configuredAt',
    type: 'dateRange',
  },
];

export default stabilityFilters;
